import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import GetCurrentUserService from '../../user/Services/GetCurrentUserService.js'
import {GetAlertUserAlertsError} from '../Errors/GetAlertUserAlertsError.js'
import HTTPUserAlertsRepository from '../Repositories/HTTPUserAlertsRepository.js'

class GetAlertUserAlertsUseCase extends UseCase {
  #repository
  #service

  #handleError(error) {
    if (GetAlertUserAlertsError.isGetAlertUserAlertsError({error})) return Promise.reject(error)
    return Promise.reject(GetAlertUserAlertsError.createGenericError({cause: error}))
  }

  constructor({repository, service}) {
    super()
    this.#repository = repository
    this.#service = service
  }

  static create({config}) {
    return new GetAlertUserAlertsUseCase({
      repository: HTTPUserAlertsRepository.create({config}),
      service: GetCurrentUserService.create({config})
    })
  }

  @tracer({metric: 'GetAlertUserAlertsUseCase#execute'})
  @AsyncInlineError()
  async execute({alertId, userId}) {
    try {
      if (!alertId) throw GetAlertUserAlertsError.createInvalidParametersError()

      const userEntity = await this.#service.execute()

      if (!userEntity && !userId) throw GetAlertUserAlertsError.createNotAuthenticatedError()

      const [error, response] = await this.#repository.getUserAlert({
        alertId,
        userId: userId || userEntity.getId()
      })

      return error ? this.#handleError(error) : response
    } catch (error) {
      return this.#handleError(error)
    }
  }
}

export const factory = GetAlertUserAlertsUseCase.create
